import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { ExploreService } from '@services/explore-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-explore-contact-banners',
  templateUrl: './explore-contact-banners.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class ExploreContactBannersComponent implements OnInit, OnDestroy {
  @Input('userStatus') userStatus: any;
  @Input('user') user: any;
  @Input() hideExplorePanel: boolean = false;
  @Output('optedForSupport') optedForSupport: EventEmitter<string> = new EventEmitter();
  @Output('exploreSectionRedirect') exploreSectionRedirect: EventEmitter<void> = new EventEmitter();

  showExploreSection: boolean = false;
  private readonly exploreSubscription: Subscription;

  constructor(
    public readonly conn: ConnectionService,
    private readonly exploreService: ExploreService
  ) {
    // Subscribe to explore visibility changes
    this.exploreSubscription = this.exploreService.showExploreTab$.subscribe(
      (showTab: boolean) => {
        this.showExploreSection = showTab;
      }
    );
  }

  async ngOnInit(): Promise<void> {
    const experiments = await this.conn.findUserActiveExperiments();
    // Let the service handle the experiment logic
    this.exploreService.handleExploreTabExperiment(
      experiments,
      this.user?.get('orderState')
    );
  }

  ngOnDestroy(): void {
    if (this.exploreSubscription) {
      this.exploreSubscription.unsubscribe();
    }
  }

  handleSupport(param: string): void {
    this.optedForSupport.emit(param);
  }

  handleExplore(): void {
    this.exploreSectionRedirect.emit();
  }
}
